import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { sessionsActions } from 'features/sessions';

const useSessions = () => {
  const dispatch = useDispatch();
  const getManagerSessions = useCallback(({ manager_id, offset }) => dispatch(sessionsActions.getManagerSessions({ manager_id, offset })), [dispatch]);
  const getSession = useCallback((id) => dispatch(sessionsActions.getSession(id)), [dispatch]);
  const createSession = useCallback(({ email, password, confirmation_code }) => dispatch(sessionsActions.createSession({ email, password, confirmation_code })), [dispatch]);
  const deleteActiveSession = useCallback(() => dispatch(sessionsActions.deleteActiveSession()), [dispatch]);
  const deleteSession = useCallback((id) => dispatch(sessionsActions.deleteSession(id)), [dispatch]);
  const setLocalSession = useCallback(session => dispatch(sessionsActions.setLocalSession(session)), [dispatch]);
  const clearLocalManagerSessions = useCallback(() => dispatch(sessionsActions.clearLocalManagerSessions()), [dispatch]);

  return { 
    getManagerSessions, 
    getSession, 
    createSession, 
    deleteActiveSession, 
    deleteSession, 
    setLocalSession,
    clearLocalManagerSessions 
  };
};

export default useSessions;